import { render, staticRenderFns } from "./KoLArchiveList.vue?vue&type=template&id=12ee5eea&scoped=true"
import script from "./KoLArchiveList.vue?vue&type=script&lang=js"
export * from "./KoLArchiveList.vue?vue&type=script&lang=js"
import style0 from "./KoLArchiveList.vue?vue&type=style&index=0&id=12ee5eea&prod&scoped=true&lang=css"
import style1 from "./KoLArchiveList.vue?vue&type=style&index=1&id=12ee5eea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee5eea",
  null
  
)

export default component.exports